import _implicitStylesheets from "./skillOverview.css";
import _implicitScopedStylesheets from "./skillOverview.scoped.css?scoped=true";
import _axImage from "ax/image";
import _wdsMarkdown from "wds/markdown";
import _wdsTitledGroup from "wds/titledGroup";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="overview-section${0}" data-testid="description-section"${2}><h3 type-style="display-6" class="section-heading${0}" data-testid="primary-heading"${2}>${"t2"}</h3><p type-style="body-2" class="section-text description-text${0}" data-testid="description-text"${2}>${"t4"}</p></div>`;
const $fragment2 = parseFragment`<h3 type-style="display-6" class="section-heading${0}"${2}>${"t1"}</h3>`;
const stc0 = {
  classMap: {
    "wrapper": true
  },
  key: 0
};
const stc1 = {
  "overview-section": true,
  "preview-image-section": true
};
const stc2 = {
  "data-testid": "preview-image-section"
};
const stc3 = {
  "preview-image": true
};
const stc4 = {
  classMap: {
    "overview-section": true
  },
  attrs: {
    "data-testid": "markdown-section"
  },
  key: 5
};
const stc5 = {
  classMap: {
    "overview-section": true,
    "categories-section": true
  },
  attrs: {
    "data-testid": "categories-section"
  },
  key: 7
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, c: api_custom_element, h: api_element, i: api_iterator, f: api_flatten} = $api;
  return [api_element("div", stc0, api_flatten([api_static_fragment($fragment1, 2, [api_static_part(2, null, api_dynamic_text($cmp.primaryHeadingLabel)), api_static_part(4, null, api_dynamic_text($cmp.description))]), api_iterator($cmp.previewImageUrls, function (imageUrl) {
    return api_element("div", {
      classMap: stc1,
      attrs: stc2,
      key: api_key(3, imageUrl)
    }, [api_custom_element("ax-image", _axImage, {
      classMap: stc3,
      props: {
        "imgSrc": imageUrl,
        "alt": $cmp.previewImageAlt,
        "width": "100%",
        "height": "auto",
        "variant": "rounded"
      },
      key: 4
    })]);
  }), $cmp.showMarkdown ? api_element("div", stc4, [api_custom_element("wds-markdown", _wdsMarkdown, {
    props: {
      "value": $cmp.markdownBody,
      "linkBaseUrl": $cmp.markdownLinkBaseUrl,
      "imageBaseUrl": $cmp.markdownImageBaseUrl,
      "allowedImageRootUrls": $cmp.markdownAllowedImageRootUrls
    },
    key: 6
  })]) : null, $cmp.hasDomainBadges ? api_element("div", stc5, [api_static_fragment($fragment2, 9, [api_static_part(1, null, api_dynamic_text($cmp.categoriesLabel))]), api_custom_element("wds-titled-group", _wdsTitledGroup, {
    props: {
      "title": $cmp.domainsLabel,
      "badges": $cmp.domainBadges
    },
    key: 10
  })]) : null]))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4r40g30d6k9";
tmpl.legacyStylesheetToken = "undefined-_skillOverview";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
